import {
    WidgetActionType,
    WidgetTypeActionPayload,
} from 'widgets/store/actions';
import { Action } from 'store/store';
import { WidgetType } from 'widgets/WidgetType';

export interface ToggleGridColumnSortActionPayload<T extends string>
    extends WidgetTypeActionPayload {
    columnId: T;
    defaultSortDesc: boolean;
}

export interface ToggleGridColumnSortAction<T extends string>
    extends Action<
        WidgetActionType.WIDGET_TOGGLE_GRID_COLUMN_SORT,
        ToggleGridColumnSortActionPayload<T>
    > {
    payload: ToggleGridColumnSortActionPayload<T>;
}

export interface ToggleGridSingleColumnSortAction<T extends string>
    extends Action<
        WidgetActionType.WIDGET_TOGGLE_GRID_SINGLE_COLUMN_SORT,
        ToggleGridColumnSortActionPayload<T>
    > {
    payload: ToggleGridColumnSortActionPayload<T>;
}

export function createToggleGridColumnSortAction<T extends string>(
    widgetType: WidgetType,
    widgetKey: string
) {
    if (!widgetType || !widgetKey) {
        throw new Error('No widget type or widget key received');
    }
    return (
        columnId: T,
        defaultSortDesc: boolean
    ): ToggleGridColumnSortAction<T> => ({
        type: WidgetActionType.WIDGET_TOGGLE_GRID_COLUMN_SORT,
        payload: { widgetType, widgetKey, columnId, defaultSortDesc },
    });
}

export function createToggleGridSingleColumnSortAction<T extends string>(
    widgetType: WidgetType,
    widgetKey: string
) {
    if (!widgetType || !widgetKey) {
        throw new Error('No widget type or widget key received');
    }
    return (
        columnId: T,
        defaultSortDesc: boolean
    ): ToggleGridSingleColumnSortAction<T> => ({
        type: WidgetActionType.WIDGET_TOGGLE_GRID_SINGLE_COLUMN_SORT,
        payload: { widgetType, widgetKey, columnId, defaultSortDesc },
    });
}
